<template>
  <div>
    <v-flex xs12>
      <v-card color="primary">
        <v-card-text class="display-2 white--text tpx-0">Bem-vindo ao {{ nomeEmpresa}} Pré-Pago</v-card-text>
      </v-card>
      <v-flex xs10 offset-xs1 class="headline"></v-flex>
      <v-flex
        xs10
        offset-xs1
        class="body-2 font-weight-regular font-italic"
        style="margin-top:100px"
      >
        <p></p>
        <p>Seja bem-vindo ao Sistema {{nomeEmpresa}} Pré-Pago!</p>
        <p>Seu cartão virtual será gerado ao inserir crédito pela primeira vez.</p>
        <p>
          O crédito inicial e as demais recargas poderão ser feitas em uma de nossas lojas ou pelo APP para Android ou IOS. Então,
          não perca tempo! Baixe o aplicativo {{nomeEmpresa}} Pré-Pago pela Play Store ou App Store!
        </p>

        <v-btn class="white--text" @click="entrar()" color="sucesso" value="justify">
          Acessar
          <v-icon right>check</v-icon>
        </v-btn>
      </v-flex>
    </v-flex>
  </div>
</template>

<script>
export default {
  data: () => ({
    teste: "",
    nomeEmpresa: ""
  }),
  created() {
    let currentUrl = window.location.hostname;
    let imgUrl = currentUrl.split(".");
    console.log(this.imgUrl);
    if (imgUrl[0] == "omminiprepago") {
      this.nomeEmpresa = "OMMINI";
    } else {
      this.nomeEmpresa = imgUrl[0].toUpperCase();
    }
    //console.log(this.imgTopo);
  },
  methods: {
    entrar() {
      this.$router.push("Login");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue